import { render, staticRenderFns } from "./BodyNavBar.vue?vue&type=template&id=c083b616&scoped=true"
import script from "./BodyNavBar.vue?vue&type=script&lang=js"
export * from "./BodyNavBar.vue?vue&type=script&lang=js"
import style0 from "./BodyNavBar.vue?vue&type=style&index=0&id=c083b616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c083b616",
  null
  
)

export default component.exports